import React from 'react'
import Table from "react-bootstrap/Table";

export default function AutomomatedFilteredHeader(props) {

  const {headerStats, avgTicketPrice, spaces, utilization } = props
  const totalSpaces = Number.isFinite(Number(spaces)) ? Number(spaces) : 0;
  const utilizationBase = Number.isFinite(Number(utilization)) ? Number(utilization) : 0;
  const utilizationPct =
    totalSpaces > 0 ? ((utilizationBase / totalSpaces) * 100).toFixed(2) : "0.00";
  const totalsRow = Array.isArray(headerStats) && headerStats.length > 0
    ? headerStats[headerStats.length - 1]
    : { TInCount: 0, MInCount: 0 };

  return (
    <Table striped bordered className="table-sm header-mobile">
      <thead>
        <tr className="table-warning">
          <th>Total Spaces</th>
          <th>Total T. Parked</th>
          <th>Total M. Parked</th>
          <th>Total Parked</th>
          <th>Garage Utilization</th>
          <th>Avg. Price</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{totalSpaces}</td>
          <td>{totalsRow.TInCount}</td>
          <td>{totalsRow.MInCount}</td>
          <td>{totalsRow.MInCount + totalsRow.TInCount}</td>
          <td>{utilizationPct}%</td>
          <td>${avgTicketPrice}</td>
        </tr>
      </tbody>
    </Table>
  )
}
